import { CHANGE_TAB } from "../actions/tabAction";

const initialState = {
  initialTab: 0,
};

const tabReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_TAB: {
      return {
        ...state,
        initialTab: action.payload,
      };
    }
    default:
      return state;
  }
};

export default tabReducer;
